import { render, staticRenderFns } from "./listTypeFormChart.vue?vue&type=template&id=30c2a6a4&scoped=true&"
import script from "./listTypeFormChart.vue?vue&type=script&lang=js&"
export * from "./listTypeFormChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2a6a4",
  null
  
)

export default component.exports